import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=ef6b8ae2&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6b8ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6b8ae2')) {
      api.createRecord('ef6b8ae2', component.options)
    } else {
      api.reload('ef6b8ae2', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=ef6b8ae2&scoped=true&", function () {
      api.rerender('ef6b8ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sN1jSJLlG1Wi/JS/comp/Voucher-Unit.vue"
export default component.exports